// src/services/loanService.js
// FIXED: Removed all broken [api.post](http://api.post) and [response.data](http://response.data) markdown link syntax

import api from './api';

export const loanService = {
  createApplication: async (carId) => {
    try {
      const response = await api.post('/loan_applications', { car_id: carId });
      return response.data;
    } catch (error) {
      console.error('Error creating loan application:', error);
      throw error;
    }
  },

  submitApplicant: async (applicationId, data) => {
    try {
      const response = await api.patch(`/loan_applications/${applicationId}/applicant`, { applicant: data });
      return response.data;
    } catch (error) {
      console.error('Error submitting applicant details:', error);
      throw error;
    }
  },

  submitAddress: async (applicationId, data) => {
    try {
      const response = await api.patch(`/loan_applications/${applicationId}/address`, { address: data });
      return response.data;
    } catch (error) {
      console.error('Error submitting address:', error);
      throw error;
    }
  },

  submitEmployment: async (applicationId, data) => {
    try {
      const response = await api.patch(`/loan_applications/${applicationId}/employment`, { employment: data });
      return response.data;
    } catch (error) {
      console.error('Error submitting employment details:', error);
      throw error;
    }
  },

  submitFinancials: async (applicationId, data) => {
    try {
      const response = await api.patch(`/loan_applications/${applicationId}/financials`, { financial: data });
      return response.data;
    } catch (error) {
      console.error('Error submitting financials:', error);
      throw error;
    }
  },

  sendOTP: async (applicationId, mobile) => {
    try {
      const response = await api.post(`/loan_applications/${applicationId}/send_otp`, { mobile });
      return response.data;
    } catch (error) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  },

  verifyOTP: async (applicationId, otpId, otpCode) => {
    try {
      const response = await api.post(`/loan_applications/${applicationId}/verify_otp`, {
        otp_id: otpId,
        otp_code: otpCode,
      });
      return response.data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  },

  calculateEligibility: async (applicationId) => {
    try {
      const response = await api.post(`/loan_applications/${applicationId}/calculate_eligibility`);
      return response.data;
    } catch (error) {
      console.error('Error calculating eligibility:', error);
      throw error;
    }
  },

  getApplication: async (applicationId) => {
    try {
      const response = await api.get(`/loan_applications/${applicationId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting application:', error);
      throw error;
    }
  },
};